import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { VendorModel } from 'src/app/modules/authentication/components/models/autentication-dto.models';
import { TypeofTender, VendorStatus } from 'src/app/modules/authentication/components/models/authentication-actions.enum';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { Utils } from 'src/app/shared/helpers/utils.helper';
import { ApiService } from 'src/app/shared/services/api.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { MessageService } from 'src/app/shared/services/MessageService.service';
import { UserService } from 'src/app/shared/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  vendor : any;
  Messages: any[] = [];
  tenders: any[] = [];
  filteredTenders: any[] = [];
  publicTenderCount = 0;
  privateTenderCount = 0;
  tenderMessage : string;
  bisMessage : string;
  bids: any[] = [];
  openBidCount = 0;
  submittedBidCount = 0;
  
  constructor(
    private _userService: UserService,
    private _router: Router,
    private _http: HttpClient,
    private _loaderService: LoaderService,
    private messageService: MessageService,

  ) { }
  AppConstants = AppConstants;
  VendorStatus = VendorStatus;

  get user() {
    return this._userService.user;
  }
  
  ngOnInit() : void {
     this.getDashboardData(); // Load messages on component init
     this.loadMessages(); // Load messages on component init
  }

  /**
   * Check if user can edit the application
   * Returns true only if vendor exists, status exists, and status is not Submitted or Draft
   */
  canEditApplication(): boolean {
    // Don't show button if vendor data is not loaded yet
    if (!this.vendor || !this.vendor.status) {
      return false;
    }

    // Normalize status to handle case sensitivity
    const status = String(this.vendor.status).trim().toLowerCase();

    // Check against enum values (case-insensitive comparison)
    // Hide edit button for Submitted, Draft, and Rejected statuses
    return status !== VendorStatus.Submitted.toLowerCase() &&
           status !== VendorStatus.Draft.toLowerCase() &&
           status !== VendorStatus.Rejected.toLowerCase();
  }

  updateTenderCounts() {
    this.publicTenderCount = this.tenders.filter(
      (tender) => tender.typeofTender === TypeofTender.Public
    ).length;
  
    this.privateTenderCount = this.tenders.filter(
      (tender) => tender.typeofTender === TypeofTender.Private
    ).length;
  }


  // Subscribe to messages$ observable from the service
  private loadMessages(): void {
    this.messageService.messages$.subscribe({
      next: (messages: any) => {
        this.Messages = messages;
        console.log(this.Messages); // Log the messages
      },
      error: (err) => {
        console.error('Error fetching messages:', err);
      }
    });
  }

     //#region API Service
     private createApiService(): ApiService {
      const apiService = new ApiService(this._http);
      apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
      return apiService;
    }
    //#endregion

    formatDate(dateString: string): string {
      if (dateString != null) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0');
      // Return formatted date in yyyy-mm-dd format
      return `${day}-${month}-${year}`;
      }
      return '';
    }

    
    getVendorStatusDisplay(): string {
      const status = (this.vendor?.status || '').toString().replace(/\s+/g, '').toLowerCase();
      if (status === VendorStatus.ChangeRequested.toLowerCase() || status === 'changerequested') {
        return 'Change Request';
      }

      return this.vendor?.status || '';
    }

    getStatusColor(): string {
      const status = (this.vendor?.status || '').toString().replace(/\s+/g, '').toLowerCase();
      switch (status) {
        case VendorStatus.Draft.toLowerCase():
        case VendorStatus.Submitted.toLowerCase():
        case VendorStatus.InReview.toLowerCase():
        case VendorStatus.ChangeRequested.toLowerCase():
        case 'changerequested':
          return '#F59E0B'; // Amber - pending / in progress
        case VendorStatus.Approved.toLowerCase():
          return '#16A34A'; // Green - OK
        case VendorStatus.Rejected.toLowerCase():
          return '#DC2626'; // Red - stop / rejected
        default:
          return '#6B7280';
      }
    }

    getTenderStatusColor(status: string): { color: string, backgroundColor: string } {
      const statusLower = (status || '').toLowerCase();

      switch (statusLower) {
        case 'open':
          return { color: '#15803D', backgroundColor: '#DCFCE7' }; // Green
        case 'closed':
          return { color: '#B45309', backgroundColor: '#FEF3C7' }; // Amber â€” ended
        case 'cancelled':
          return { color: '#B91C1C', backgroundColor: '#FEE2E2' }; // Red
        default:
          return { color: '#4B5563', backgroundColor: '#F3F4F6' };
      }
    }
    



  // async GetProfile(){
  //   let apiService = this.createApiService();
  //   // var payload = null;
  //   // var keyValuePair = {id: this.serviceId};
  //   this._loaderService.showLoader();
  //   let req$= apiService.get(AppConstants.CONTROLLERS.VENDOR, AppConstants.ACTIONS.GetVendorDetails, true, environment.APIs_PREFIX );
  //   await lastValueFrom(req$).then((data:any) => {
  //     this.vendor = data.data;
  //     console.log(this.vendor);
  //   },
  //   (err: HttpErrorResponse) => {
  //     console.log(err);
  //   }) .finally(() => {
  //     this._loaderService.hideLoader();
  //   });
  // }
  
  updateTenderMessage() {
    const openTendersCount = this.tenders.filter((tender) => tender.status === 'Open').length;
  
    if (openTendersCount > 0) {
      this.tenderMessage = `You have ${openTendersCount} Opened tenders`;
    } else {
      this.tenderMessage = "You don't have any tenders yet";
    }
  }

  async getDashboardData() {
    let apiService = this.createApiService(); // Initialize your API service
    this._loaderService.showLoader(); // Show loader while fetching dashboard data
  
    let req$ = apiService.get(
      AppConstants.CONTROLLERS.Common, // Replace with your common controller
      AppConstants.ACTIONS.GetDashboardData, // Replace with your dashboard endpoint action
      true, // Authentication flag
      environment.APIs_PREFIX // API prefix
    );
  
    await lastValueFrom(req$).then(
      (data: any) => {
        const dashboardData = data.data;
  
        // Assign vendor-specific data
        this.vendor = {
          vendorId: dashboardData.vendor.vendorID,
          vendorName: dashboardData.vendor.vendorName,
          status: dashboardData.vendor.status,
          applicationSubmissionDate: dashboardData.vendor.applicationSubmissionDate,
          lastApplicationModifyDate: dashboardData.vendor.lastApplicationModifyDate
        };
  
        // Assign tender counts
        this.publicTenderCount = dashboardData.tender?.publicCount || 0;
        this.privateTenderCount = dashboardData.tender?.privateCount || 0;
  
        // Calculate tender message based on open tenders count
        const openTendersCount = (dashboardData.tender?.publicCount  + dashboardData.tender?.privateCount) || 0;
        this.tenderMessage =
          openTendersCount > 0
            ? `You have ${openTendersCount} open tenders`
            : "You don't have any tenders yet";
    
        // Assign latest tenders
        this.tenders = dashboardData.tender.latestFiveTenders || [];
        this.filteredTenders = this.tenders.slice(0, 5);
  
        // Assign bid counts
        this.openBidCount = dashboardData.bid?.open || 0;
        this.submittedBidCount = dashboardData.bid?.submitted || 0;
  
        this.bisMessage =
        this.openBidCount  > 0
          ? `You have ${ this.openBidCount } open bids`
          : "You don't have any bids yet";

        console.log('Dashboard Data:', dashboardData); // Optional: Log the dashboard data for debugging
      },
      (err: HttpErrorResponse) => {
        console.error('Error fetching dashboard data:', err); // Log any errors
      }
    ).finally(() => {
      this._loaderService.hideLoader(); // Hide loader once the call is complete
    });
  }
  
  

}


